import auth from '@/middleware/modules/auth'

const EmbedAnalytics = () => import(/* webpackChunkName: "_v-embed_analytics" */ '@/views/embed_analytics/Analytics.vue')
const AnalyticsEmbeds = () => import(/* webpackChunkName: "_v-embed_analytics" */ '@/views/embed_analytics/Embeds.vue')
const AnalyticsMedias = () => import(/* webpackChunkName: "_v-embed_analytics" */ '@/views/embed_analytics/Medias.vue')
const AnalyticsPins = () => import(/* webpackChunkName: "_v-embed_analytics" */ '@/views/embed_analytics/Pins.vue')
export default [
  {
    path: 'analytics',
    name: 'analytics-embed',
    component: EmbedAnalytics,
    redirect: { name: 'analytics-embed-embeds' },
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
    children: [
      {
        path: 'embeds',
        name: 'analytics-embed-embeds',
        component: AnalyticsEmbeds,
        meta: {
          layout: 'app-layout',
          tab: 'embeds',
          middleware: [auth],
        },
      },
      {
        path: 'embeds/medias',
        name: 'analytics-embed-medias',
        component: AnalyticsMedias,
        meta: {
          layout: 'app-layout',
          tab: 'medias',
          middleware: [auth],
        },
      },
      {
        path: 'embeds/pins',
        name: 'analytics-embed-pins',
        component: AnalyticsPins,
        meta: {
          layout: 'app-layout',
          tab: 'pins',
          middleware: [auth],
        },
      },
    ],
  },
]
